import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  colorClassName?: string; // Allows passing Tailwind text color classes e.g., 'text-text-secondary-light'
  className?: string; // For additional wrapper styling
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  colorClassName = 'text-text-secondary-light', // Default color
  className,
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  };

  const combinedClassName = `
    animate-spin
    ${sizeClasses[size]}
    ${colorClassName}
    ${className || ''}
  `;

  return (
    <svg
      className={combinedClassName.trim()}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      aria-label='Loading'
      role='status'
    >
      <circle
        className='opacity-25'
        cx='12'
        cy='12'
        r='10'
        stroke='currentColor'
        strokeWidth='4'
      ></circle>
      <path
        className='opacity-75'
        fill='currentColor'
        d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
      ></path>
    </svg>
  );
};

export default LoadingSpinner;
